import { IconProps } from './index';

const ArrowUpLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M6.83833 3.21869V11.3334H5.50499V3.21869L1.92899 6.79469L0.986328 5.85202L6.17166 0.666687L11.357 5.85202L10.4143 6.79469L6.83833 3.21869Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ArrowUpLine;
